import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { api_url } from "../../constant/constant";
import { toast } from "react-toastify"; // ✅ Make sure to install react-toastify

const EmailLogs = ({ LearningManager_id }) => {
  const [emailLogs, setEmailLogs] = useState([]);
  const [filteredEmailLogs, setFilteredEmailLogs] = useState([]);
  const [error, setError] = useState("");
  const { t } = useTranslation();
  const [isSending, setIsSending] = useState(false);

  const [links, setLinks] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);

  // ✅ Handle Send Email
  // ✅ Handle Send Email
const handleSendEmail = async (id) => {
  setIsSending(true);

  try {
    setSendEmail(true);
    const token = localStorage.getItem("userToken");

    const requestBody = {
      campaign_id: id,
    };

    const response = await fetch(`${api_url}/learning-campaigns-emails/send-emails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    });

    const result = await response.json();

    if (response.ok) {
      toast.success(t("emailsentsuccessfully"));
    } else {
      // ✅ Show custom message if campaign or server missing
      if (result.message === "Campaign settings or email server is missing.") {
        toast.error(t("campaignOrEmailServerMissing") || result.message);
      } else {
        toast.error(result.message || t("failedtosendemail"));
      }
    }
  } catch (error) {
    console.error("Error sending email:", error);
    toast.error(t("erroroccuredsendingemail"));
  } finally {
    setSendEmail(false);
    setIsSending(false);
  }
};


  // ✅ Fetch Email Logs
  const fetchEmaillog = async (url) => {
    let page = 1;
    if (url !== "") {
      const temp = url.split("?page=");
      page = parseInt(temp[1]);
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(
        `${api_url}/learning-campaigns-emails/${LearningManager_id}/email-logs?page=${page}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setEmailLogs(result.data?.data || []);
      setFilteredEmailLogs(result.data?.data || []);
      setLinks(result.data?.links || []);
    } catch (error) {
      console.error("Error fetching email logs:", error);
      setError(t("errorFetchingEmailLogs"));
    } finally {
      setLoading(false);
    }
  };

  // ✅ Fetch data on mount and when ID changes
  useEffect(() => {
    if (LearningManager_id) {
      fetchEmaillog("");
    }
  }, [LearningManager_id]);

  // ✅ Filter email logs based on search input
  useEffect(() => {
    if (searchValue !== "") {
      const filteredData = emailLogs.filter(
        (item) =>
          (item.email?.toLowerCase() || "").includes(searchValue.toLowerCase()) ||
          (item.username?.toLowerCase() || "").includes(searchValue.toLowerCase()) ||
          (item.status?.toLowerCase() || "").includes(searchValue.toLowerCase())
      );
      setFilteredEmailLogs(filteredData);
    } else {
      setFilteredEmailLogs(emailLogs);
    }
  }, [searchValue, emailLogs]);

  return (
    
    <div className="p-4 mb-4">
      <div className="primaryBlueBox mb-4" id="pa">
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">{t("SearchEmailLogs")}</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder={t("Searchbyusername")}
                aria-label="Search by name"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <button
                className="btn btn-outline-secondary btnSearchIcon"
                type="button"
              >
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>
          <div class="col-md-1"><div class="vrLine"></div></div>
          <div className="col-md-6" >
          <button
              className='btnWhiteGradient mt-4' 
              onClick={(e) => {
                e.stopPropagation();
                handleSendEmail(LearningManager_id);
              }}
              style={{
                backgroundColor: 'gray',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '30px',
              }}
              disabled={isSending}
            >
              {isSending ? (
                <span
                  className='spinner-border spinner-border-sm me-2'
                  role='status'
                  aria-hidden='true'
                ></span>
              ) : (
                <i className='bi bi-envelope me-2 h6'></i>
              )}
              {t('SendEmail')}
            </button>
            
          </div>
        </div>
      </div>

      <div className="container mt-4">
        <h2>{t("EmailLogs")}</h2>
        {error && <p className="text-danger">{error}</p>}

        {/* Show loading spinner while data is being fetched */}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center mt-5">
            <div
              className="spinner-border loader-api"
              role="status"
              style={{
                borderTopColor: "#6897CB",
                borderBottomColor: "#6897CB",
                borderLeftColor: "#6897CB",
                marginTop: "50px",
              }}
            ></div>
          </div>
        ) : (
          <div style={{ maxHeight: "400px", overflow: "auto" }}>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>{t("Username")}</th>
                  <th>{t("Email")}</th>
                  <th>{t("Status")}</th>
                </tr>
              </thead>
              <tbody>
                {filteredEmailLogs.length > 0 ? (
                  filteredEmailLogs.map((log) => (
                    <tr key={log.id}>
                      <td>{log.username}</td>
                      <td>{log.email}</td>
                      <td>{log.status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      {t("NoEmailLogsFound")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination */}
        <div className="navigationWrapper">
          <ul>
            {links.map((link, index) => (
              <li
                key={index}
                className={`${link.active ? "active" : ""} ${
                  link.url === null ? "disabled" : ""
                }`}
                onClick={
                  link.url !== null ? () => fetchEmaillog(link.url) : undefined
                }
              >
                <div dangerouslySetInnerHTML={{ __html: link.label }} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EmailLogs;
